export const BLOG_CONTACT_HREF = '/#contact';

export const FOOTER_NAV_ITEMS = [
  { key: 'home', label: 'Home' },
  { key: 'blog', label: 'Blog' },
  { key: 'privacy', label: 'Privacy' },
  { key: 'affiliates', label: 'Affiliates' },
  { key: 'contact', label: 'Contact' },
] as const;

export type FooterNavKey = (typeof FOOTER_NAV_ITEMS)[number]['key'];

export const FOOTER_NAV_LINK_HREFS: Record<Exclude<FooterNavKey, 'contact'>, string> = {
  home: '/',
  blog: '/blog',
  privacy: '/privacy',
  affiliates: '/affiliates',
};

export function getFooterNavHref(key: FooterNavKey, context: 'landing' | 'blog'): string | null {
  if (key === 'contact') {
    return context === 'blog' ? BLOG_CONTACT_HREF : null;
  }

  return FOOTER_NAV_LINK_HREFS[key];
}

export const DRAWER_LINK_ITEMS = FOOTER_NAV_ITEMS
  .filter((item) => item.key === 'blog' || item.key === 'privacy' || item.key === 'affiliates')
  .map((item) => ({
    ...item,
    to: FOOTER_NAV_LINK_HREFS[item.key],
  }));
